import React from 'react';
import style from './style.css';

const Footer = props => {
    return (
        <div className={style.footer}>
            Report generated by SHARE | © 2025 Centervention. All rights reserved.
            <br />
            Privacy Policy:{' '}
            <a href="https://www.centervention.com/privacy-policy">www.centervention.com/privacy-policy</a>
        </div>
    );
};

Footer.propTypes = {};

export default Footer;
